import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { ButtonAddComponent } from '@component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from '@component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from '@component/button-close-dialog/button-close-dialog.component';
import { ButtonDeleteComponent } from '@component/button-delete/button-delete.component';
import { ButtonSaveComponent } from '@component/button-save/button-save.component';
import { SelectUsuariosEmpresaComponent } from '@component/select-usuarios-empresa/select-usuarios-empresa.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { BaseDto } from '@models/base/baseDto.model';
import { TiposDocumentos } from '@models/base/identificadores.model';
import { EstadoCivilDto } from '@models/estadoCivil/estadoCivilDto.model';
import { CreatePersonaRequest } from '@models/persona/createPersonaRequest.model';
import { PersonaDetailDto } from '@models/persona/personaDetailDto.model';
import { TipoDocumentoDto } from '@models/tipoDocumento/tipoDocumentoDto.model';
import { EstadoCivilService } from '@services/estadoCivil/estadoCivil.service';
import { PaisService } from '@services/pais/pais.service';
import { PersonaService } from '@services/persona/persona.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoDocumentoService } from '@services/tipoDocumento/tipoDocumento.service';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { NgxMaskDirective } from 'ngx-mask';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { isFalsy } from 'utility-types';

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, AppRolesDirective, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, MatChipsModule, MatTabsModule, SelectUsuariosEmpresaComponent, NgxMaskDirective],
  selector: 'app-dialog-create-persona-simple',
  templateUrl: './dialog-create-persona-simple.component.html',
  styleUrls: ['./dialog-create-persona-simple.component.css']
})
export class DialogCreatePersonaSimpleComponent {

  panelOpenState = true;
  titulo: string = '';
  subMenuActive: boolean = false;
  stringObject: any;
  stringJson: any;
  personaForm!: FormGroup
  public personaDetailDto: PersonaDetailDto = new PersonaDetailDto;
  lstEstadosCivilModel: EstadoCivilDto[] = [];
  lstTipoDocumentoDto: TipoDocumentoDto[] = [];
  lstPaises: BaseDto[] = [];
  localidad!: BaseDto
  submitted = false;
  parametro: string = '';
  idTipoDocumento: number = 0;
  idLocalidad: number = 0;
  idEstadoCivil: number = 0;
  idPersona: number = 0;
  valor: any
  errorMessage: string = "";
  accordionList: any;
  formBuilder: FormBuilder = new FormBuilder;

  get f() { return this.personaForm.controls; }

  localidadSelec: number = 0;
  formLocalidad: FormControl = new FormControl("", Validators.compose([Validators.required]));
  filteredOptions?: Observable<any[]>;


  constructor(

    public dialogRef: MatDialogRef<DialogCreatePersonaSimpleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private PersonaService: PersonaService,
    private tipoDocumentoService: TipoDocumentoService,
    private paisService: PaisService,
    private router: Router,
    private snackBar: SnackBarService,
    private estadoCivilService: EstadoCivilService,
    private spinner: NgxSpinnerService,

  ) {

    this.personaForm = this.formBuilder.group({
      //Persona
      Nombre: ["", Validators.compose([Validators.required, Validators.maxLength(150)])],
      Apellido: ['', Validators.compose([Validators.maxLength(150)])],
      NroDocumento: ['',
        Validators.compose([ Validators.maxLength(50)])],
        // this.validaPersonaByNroDocYTipoDoc.bind(this)],
      TelefonoPrincipal: ['', Validators.compose([Validators.required,Validators.maxLength(30)])],
      TelefonoAlternativo: ['',Validators.compose([Validators.maxLength(30)])],
      TelefonoLaboral: ['',Validators.compose([Validators.maxLength(30)])],
      Sexo: [''],
      Correo: ['', Validators.compose([Validators.required, Validators.email, Validators.maxLength(50)])],
      FechaNacimiento: [''],
      Ubicacion: ['', Validators.compose([Validators.maxLength(200)])],
      UbicacionLaboral: ['', Validators.compose([Validators.maxLength(150)])],
      Pais: [''],
      CodigoPostal: ['', Validators.compose([Validators.maxLength(8)])],
      EstadoCivil: [''],
      TiposDocumento: [''],
      Ocupacion: ['', Validators.compose([Validators.maxLength(50)])],
      Observacion: ['', Validators.compose([Validators.maxLength(2000)])]
    },
      {
        //validator:tipoDocNroDocValidator(this.idPersona,"TiposDocumento","NroDocumento",PersonaService)
      });


  }

  ngOnInit(): void {
    this.idPersona = 0
    this.getAllTiposDocumentos();
    this.setDefault()
  }

  validaDocumentosSegunTipoDocumento(){
    this.personaForm.controls["TiposDocumento"].valueChanges.subscribe(valor => {
      //Obtenemos el control ya instanciado en el formulario.
      let tiposDocumentoControl = this.personaForm.controls["TiposDocumento"];

      //Quitamos todas las validaciones del control.
      //tiposDocumentoControl.clearValidators();

      //Agregamos la validacion segun el caso:
      switch (valor) {
        case TiposDocumentos.DNI:
          //Se agregan de nuevo todas las validaciones que necesites.
          //En este caso solo agregue la que me parecio oportuna.
          tiposDocumentoControl.setValidators([Validators.pattern("^[0-9]*$")]);
          break;
        case TiposDocumentos.PASS:
          //En el caso del alfanumerico no es necesario aplicar
          // validaciones. Si necesitas un required aqui lo debes poner.
          break;
      }

      //Para evitar problemas con la validacion marcamos el campo con
      // dirty, de esta manera se ejecutan de nuevo las validaciones
      tiposDocumentoControl.markAsDirty()
      //Recalculamos el estado del campo para que cambie el estado
      // del formulario.
      tiposDocumentoControl.updateValueAndValidity()
    });
  }

  setDefault() {
    this.personaForm.controls["NroDocumento"].disable();
  }

  selectTipoDocumento(event: any) {
    this.idTipoDocumento = event
    if (this.idTipoDocumento != 0) {
      this.personaForm.controls["NroDocumento"].enable();
      this.personaForm.controls["NroDocumento"].setValue("");
    }
    else
      this.personaForm.controls["NroDocumento"].disable();

  }


  seleccionaLocalidad(data: BaseDto) {
    this.localidad = data
  }

  onSubmit() {
    this.submitted = true;
    if (this.personaForm.invalid) {
      return;
    }
    const createPersonaRequest: CreatePersonaRequest = this.setPersonaDetailDto();
    this.spinner.show("spPersona")
    this.PersonaService.create(createPersonaRequest)
      .subscribe(
        data => {
          this.spinner.hide("spPersona")
          this.idPersona = data.id
          this.snackBar.showSuccess(this.personaForm.value['Nombre'] + ", " +this.personaForm.value['Apellido'] +
            ' se registro correctamente.', "");
            this.getPersonaById(data.id)
          this.dialogRef.close(data)
        },
        error => {
          this.spinner.hide("spPersona")
          this.snackBar.showError(error, "Error");
        })
  }

  getPersonaById(id:number) {
    this.spinner.show("spPersona")
    this.PersonaService.getPersonaById(id)
      .subscribe(
        data => {
          this.spinner.hide("spPersona")
          this.PersonaService.agregarPersona(data);
        },
        error => {
          this.spinner.hide("spPersona")
          this.snackBar.showError(error, "Error");
        })
  }

   getAllTiposDocumentos() {
    this.spinner.show("spTiposDocumento")
    this.tipoDocumentoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTiposDocumento")
          this.lstTipoDocumentoDto = data
        },
        error => {
          this.spinner.hide("spTiposDocumento")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllPaises() {
    this.spinner.show("spPaises")
    this.paisService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spPaises")
          this.lstPaises = data
        },
        error => {
          this.spinner.hide("spPaises")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosCivil() {
    this.spinner.show("spEstadosCivil")
    this.estadoCivilService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spEstadosCivil")
          this.lstEstadosCivilModel = data
        },
        error => {
          this.spinner.hide("spEstadosCivil")
          this.snackBar.showError(error, "Error");
        })
  }

  setPersonaDetailDto(): CreatePersonaRequest {

    const createPersonaRequest = new CreatePersonaRequest();

    createPersonaRequest.nombre = this.personaForm.controls['Nombre'].value;
    createPersonaRequest.apellido = this.personaForm.controls['Apellido'].value;
    createPersonaRequest.telefonoPrincipal = this.personaForm.controls['TelefonoPrincipal'].value
    createPersonaRequest.correo = this.personaForm.controls['Correo'].value;
    createPersonaRequest.activo = true;
    createPersonaRequest.idTipoDocumento= 1
    createPersonaRequest.idPais = 1

    return createPersonaRequest
  }

  onReset() {
    this.submitted = false;
    this.personaForm.reset();
  }

  goToPesonas() {
    this.submitted = false;
    this.personaForm.reset();
    this.router.navigate(["/personas"])
  }

  // validaPersonaByNroDocYTipoDoc(controlNroDoc: FormControl) {
  //   let idTipoDocumento = this.personaForm.controls['TiposDocumento'].value;
  //   if (controlNroDoc.value.toString().length > 7  && !isFalsy(idTipoDocumento) ) {
  //     let promesa = new Promise((resolve, reject) => {
  //       this.spinner.show("spPersonaCombo")
  //       this.PersonaService.validaPersonaByNroDocYTipoDoc(this.idPersona, controlNroDoc.value, idTipoDocumento)
  //         .subscribe(data => {
  //           if (data == true) {
  //             this.spinner.hide("spPersonaCombo")
  //             resolve({ existePersona: true })
  //           }
  //           else {
  //             this.spinner.hide("spPersonaCombo")
  //             resolve(true)
  //           }
  //         })
  //     });
  //     //
  //     return promesa;
  //   }
  //   else {
  //     let promesa = new Promise((resolve, reject) => {
  //       resolve(true)
  //     });
  //     return promesa;
  //   }
  // }

  isFalsy(valor:any){
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }

}
